module.exports = __webpack_public_path__ + "img/bgr-no-color.84af0102.png";